// extracted by mini-css-extract-plugin
module.exports = {"card":"card_card__w82QQ","card__header":"card_card__header__qHAit","card__content":"card_card__content__v0EdI","card__actions":"card_card__actions__cmXWS"};